<template>
  <section class="slide-6 pl-4.5">
    <div class="flex items-center section-header mb-7.5">
      <svg width="40" height="40" class="w-9.375 mr-7.5" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.334 8.33331L10.0007 15H3.33398V25H10.0007L18.334 31.6666V8.33331Z" stroke="#97A3CB" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M31.7837 8.21667C34.9082 11.3421 36.6635 15.5806 36.6635 20C36.6635 24.4194 34.9082 28.6579 31.7837 31.7833M25.9004 14.1C27.4626 15.6627 28.3403 17.782 28.3403 19.9917C28.3403 22.2014 27.4626 24.3206 25.9004 25.8833" stroke="#97A3CB" stroke-opacity="0.3" stroke-width="2" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="line-height: 1; color: #6e758d; letter-spacing: 0.3rem" >{{ text.blogName }}</p>
    </div>
    <slider
        :slides-container-classes="'mb-5 gap-7.5 min-h-104'"
        :slider-classes="''"
        :similar-slides="true"
        :pagination="true"
        pagination-container-classes="gap-5 pl-4.5"
        class="mb-12.5 "
    >
      <template v-slot:slides>
        <div
            class="slider-slide  w-76.25 flex flex-col"
            :class="{'active-slide': index === 0}"
            v-for="(item, index) in text.news"
            :key="index"
        >
          <div class="text relative w-76.25 mb-6">
            <p class="w-55 unactive fz-15 font-medium" style="color: rgba(110, 117, 141, 1);line-height:1.66666;">{{ item.text }}</p>
            <p class="absolute top-0 left-0 active fz-18" style="line-height:1.36666;">{{ item.text }}</p>
          </div>
          <div class="image">
            <img  :src="require('@/assets/images/slide_6/' + item.image + '.png')" alt="">
          </div>
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </slider>
    <a href="#mobile-start" class="all-projects flex justify-end items-center mr-4.5" @click="setRoute('blog')">
      <p class="uppercase fz-13 font-semibold mr-5" style="line-height: 1;">{{text.all}}</p>
      <div class="plus relative w-12.5 h-12.5 rounded-full" style="background:#fff;" >
        <div class="w-4 h-2px absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
        <div class="w-2px h-4 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" style="background:#ff2e53;"></div>
      </div>
    </a>
  </section>
</template>

<script>
import slider from "@/components/mobile/reuseable/slider";
import {mapMutations, mapState} from "vuex";

export default {
  name: "slide6",
  components:{
    slider
  },
  methods:{
    ...mapMutations(['setRoute'])
  },
  computed:{
    text(){
      return require('@/assets/text/main/slide6/' + this.lang + '.json')
    },
    ...mapState(['lang'])
  }
}
</script>

<style lang="scss">

.mobile .slide-6{
  .slider-slide{
    p,img{
      transition: all linear 0.3s;
    }
    p.active{
      opacity: 0;
    }
    p.unactive{
      opacity: 1;
    }
    img{
      width: 10.625rem;
    }
  }
  .slider-slide.active-slide{
    p.active{
      opacity: 1;
    }
    p.unactive{
      opacity: 0;
    }
    img{
      width: 19.0625rem;
    }
  }
}
.pagination {
  transition: all linear 0.3s;
}
.pagination > div > * {
  transition: all linear 0.3s;
}
.pagination .active {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 46, 83, 1);
}
</style>
